// Centralized axios configuration
// Handles axios 1.x compatibility issues with webpack/browser environments

let axios;

try {
  // Try default import first (for webpack/browser environments)
  axios = require('axios').default;
} catch (e) {
  // Fallback to regular import
  axios = require('axios');
}

// Ensure axios.create is available
if (!axios || typeof axios.create !== 'function') {
  console.error('axios.create is not available. Axios version:', axios?.VERSION || 'unknown');
  throw new Error('axios.create is not a function - check axios import');
}

module.exports = axios;
